import { render, staticRenderFns } from "./modal_atender.vue?vue&type=template&id=fa186238&scoped=true"
import script from "./modal_atender.vue?vue&type=script&lang=js"
export * from "./modal_atender.vue?vue&type=script&lang=js"
import style0 from "./modal_atender.vue?vue&type=style&index=0&id=fa186238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa186238",
  null
  
)

export default component.exports